<div class="flex flex-col">
  <div class="bg-grey-200 page-padding-y page-padding-x">
    <h3 id="h-IEC-Create-Ballot">IEC Ballot</h3>
  </div>
  <div *ngIf="loading" class="absolute opacity-50 flex items-center justify-center w-full h-full bg-white top-[1300px]">
    <app-loading-indicator [size]="64"></app-loading-indicator>
  </div>
  <form  [formGroup]="ballotForm" class="h-full bg-grey-100">
    <div class="pt-6 pb-6 page-padding-x">
      <div class="flex flex-col gap-6">

        <div class="flex flex-row justify-start gap-6">
          <div class="w-full">
            <label class="mb-2 body-large-bold" for="reference-Input" id ="reference-Label">
              Reference
            </label>
            <mat-form-field appearance="outline" class="relative w-full mt-1 " id="reference-Field">
              <input type="text"
                     id="reference-Input"
                     placeholder=""
                     aria-label="Number"
                     matInput
                     formControlName="referenceCtrl"
                    >
            </mat-form-field>
          </div>
        </div>

        <div class="flex flex-row justify-start gap-6">
          <div class="w-full">
            <label class="mb-2 body-large-bold" for="title-Input" id = "title-Label">
              Title/Description
            </label>
            <mat-form-field appearance="outline" class="relative w-full mt-1" id="title-Field">
              <input type="text"
                     id="title-Input"
                     placeholder=""
                     aria-label="Number"
                     matInput
                     formControlName="titleCtrl"
                    >

            </mat-form-field>
          </div>
        </div>

        <div class="flex flex-row justify-start gap-6">
          <div class="w-full">
            <label class="mb-2 body-large-bold" for="iec-link-Input" id = "iec-link-Label">
              IEC Link
            </label>
            <mat-form-field appearance="outline" class="relative w-full mt-1" id="iec-link-Field">
              <input type="text"
                     id="iec-link-Input"
                     placeholder=""
                     aria-label="Number"
                     matInput
                     formControlName="linkCtrl"
                    >
            </mat-form-field>
          </div>
        </div>

        <app-select-committee formControlName="committeeCtrl" [voteOptions]="voteOptions"></app-select-committee>

        <div class="flex flex-row items-start gap-6">
          <app-ballot-create-dates class="flex-1" (selectedDatesChange)="handleSelectedDatesChange($event)"></app-ballot-create-dates>
        </div>

        <div id="add-draft-files" class="flex flex-row items-start gap-6">
          <files-upload class="flex-1"  title="Attach Draft" (onFilesUpload)="addDraftFiles($event)" accept=".pdf"></files-upload>
        </div>

        <div id="add-comment-templates-files" class="flex flex-row items-start gap-6">
          <files-upload  class="flex-1"  title="Attach Comment Template" (onFilesUpload)="addCommentTemplateFiles($event)" accept=".doc,.docx"></files-upload>
        </div>

        <div class="flex justify-end gap-6 mt-5 mr-10 mb-72">
          <button type="button" class="px-8 py-3 border border-black btn btn-neutral" id="Cancel-Button" (click)="redirectToCreateBallotPage()">Cancel</button>
          <button class="px-8 py-3 btn btn-primary" [disabled]="ballotForm.invalid || this.hasInvalidDraftFile || this.hasInvalidCommentTemplate || this.loading" id="Create-Ballot-Button" (click)="createBallot()">Create Ballot</button>
        </div>
      </div>
    </div>
  </form>

</div>
